const e=({spacing:t})=>({styleOverrides:{root:{padding:t(2,0)}}});export{e as default};
